import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import type { ComponentProps, PropsWithChildren } from "react";

export function DecoratorRoundedFilterSvg({ rounded = 0.5 }: { rounded?: number }) {
  return (
    <svg className="invisible absolute w-0 h-0" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="svg-rounded-filter">
          <feGaussianBlur in="SourceGraphic" stdDeviation={rounded} result="blur" />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
            result="svg-rounded-filter"
          />
          <feComposite in="SourceGraphic" in2="svg-rounded-filter" operator="atop" />
        </filter>
      </defs>
    </svg>
  );
}

type DecoratorHatBackgroundProps = {
  wide?: boolean;
  hatClassName?: string;
} & ComponentProps<"div">;

export function DecoratorHatBackground({
  children,
  className,
  wide = false,
  hatClassName,
  ...props
}: PropsWithChildren<DecoratorHatBackgroundProps>) {
  const { view, size } = useNodeStyle();
  const isTextView = view === "text";

  return (
    <>
      <div
        {...props}
        className={twMerge(
          "flex justify-center min-h-[5px] [filter:url(#svg-rounded-filter)]",
          "absolute -top-[2px] left-1/2 -translate-x-1/2",

          !wide && "min-w-4",
          !wide && (size === "xs" || size === "xxs") && "min-w-3",

          wide && "min-w-2",
          wide && size === "xs" && "min-w-2",

          isTextView && size === "xxs" && "-top-[1px]",
          isTextView && size === "xxxs" && "-top-[0.25rem]",

          className,
        )}
      >
        <div
          className={twMerge(
            "flex items-center justify-center _h-full w-full gap-[1px] px-[2px] pt-[1px]",

            wide && "[clip-path:polygon(12%_0%,_88%_0%,_100%_100%,_0%_100%)]",
            !wide && "[clip-path:polygon(50%_0%,_50%_0%,_100%_100%,_0%_100%)]",

            size === "xs" && "pt-0",
            size === "xxs" && "pt-0",
            hatClassName,
          )}
        >
          {children}
        </div>
      </div>
      <DecoratorRoundedFilterSvg />
    </>
  );
}

export { DecoratorHatBackground as HatBackground, DecoratorRoundedFilterSvg as RoundedFilterSvg };
